import styled from 'styled-components';
import { ShadowBoxDark } from 'app/components';
import { textTransform } from 'utils';

export const SectionOrderSuccess = styled.section.attrs({
  className: 's-order-success'
})`
  padding: ${({ theme }) => theme.indent.xxl} 0;
`;

export const Inner = styled(ShadowBoxDark).attrs({
  className: 'b-order'
})`
  max-width: 690px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.indent.l};

  .svg-complete {
    display: block;
    width: 48px;
    height: 48px;
    margin: 0 auto ${({ theme }) => theme.indent.m};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    padding: ${({ theme }) => `${theme.indent.m} ${theme.indent.s}`};
  }
`;

export const Title = styled.h2.attrs({
  className: 'b-order__title'
})`
  margin-bottom: ${({ theme }) => theme.indent.l}
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 1.17;
  letter-spacing: 1px;
  text-transform: ${textTransform};
  text-align: center;
  color: ${({ theme }) => theme.color.textPrimary};
  
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    font-size: 1.6rem;
  }
`;

export const Label = styled.p.attrs({
  className: 'b-order__label'
})`
  margin-top: ${({ theme }) => theme.indent.s};
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.labelColor};
`;

export const Info = styled.p.attrs({
  className: 'b-order__info'
})`
  font-size: 1.6rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.textPrimary};
`;

export const RowCode = styled.div`
  display: flex;
  justify-content: center;
`;

export const Code = styled.div.attrs({
  className: 'b-order__code'
})`
  margin-top: ${({ theme }) => theme.indent.l};
  padding: 12px;
  color: #000;
  text-align: center;
  background: ${({ theme }) => theme.color.textPrimary};
  border-radius: ${({ theme }) => theme.indent.s};
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.25;
`;

export const RowButton = styled.div.attrs({
  className: 'b-order__actions'
})`
  margin-top: ${({ theme }) => theme.indent.xxl};
  text-align: center;

  .b-order__actions-btn {
    min-width: 200px;
  }

  .b-order__actions-btn + .b-order__actions-btn {
    margin: 0 0 0 ${({ theme }) => theme.indent.l};
  }

  .b-order__actions-btn:first-child:nth-last-child(3) ~ .b-order__actions-btn {
    min-width: 190px;
    margin: 0 0 0 ${({ theme }) => theme.indent.m};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.xl.width}) and (min-width: ${({
  theme
}) => theme.breakPoints.md.width}) {
    .b-order__actions-btn:first-child:nth-last-child(3) ~ .b-order__actions-btn {
      display: table;
      min-width: 200px;
      margin: ${({ theme }) => theme.indent.m} auto 0 auto;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    margin-top: ${({ theme }) => theme.indent.l};

    .b-order__actions-btn, .b-tickets__refund_btn {
      width: 100%;
      margin-bottom: 10px;
    }

    .b-order__actions-btn + .b-order__actions-btn {
      margin: ${({ theme }) => theme.indent.m} 0 0 0;
    }

    .b-order__actions-btn:first-child:nth-last-child(3) ~ .b-order__actions-btn {
      margin: ${({ theme }) => theme.indent.m} 0 0 0;
    }
  }
`;
